if($(window).width() < 767){
$('.section-icon-with-text .section-content-wrapper').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});

$('.section-multicoulmn-section .section-content-wrapper .group-block .group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-column').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});
}


      
    